var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentFile = function SvgAttachmentFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    fillRule: "evenodd",
    d: "M12 7.5A1.5 1.5 0 0 0 10.5 9v8.25h3V7.5H12Zm1.5 23.75h-3v9.25A1.5 1.5 0 0 0 12 42h24a1.5 1.5 0 0 0 1.5-1.5v-.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M13.5 31.25h.75v7c0 .414.336.75.75.75h24a.75.75 0 0 0 .75-.75V14.155l-.244-.28H33V6.393L32.658 6H15a.75.75 0 0 0-.75.75v10.5h-.75V6.75a1.5 1.5 0 0 1 1.5-1.5h18l7.5 8.625V38.25a1.5 1.5 0 0 1-1.347 1.492L39 39.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    fillRule: "evenodd",
    d: "M33.88 31.25V18.375c0-.621-.504-1.125-1.125-1.125H14.25V6.75A.75.75 0 0 1 15 6h17.658l.342.393v7.482h6.506l.244.28V38.25A.75.75 0 0 1 39 39H15a.75.75 0 0 1-.75-.75v-5.5h18.13a1.5 1.5 0 0 0 1.5-1.5Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    fillRule: "evenodd",
    d: "M14.25 31.25h18.505c.62 0 1.123-.502 1.125-1.121v1.121a1.5 1.5 0 0 1-1.5 1.5H14.25v-1.5Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    fillRule: "evenodd",
    d: "M9.005 17.25h23.75c.621 0 1.125.504 1.125 1.125v11.75a1.128 1.128 0 0 1-1.125 1.125H9.005a1.125 1.125 0 0 1-1.125-1.125v-11.75c0-.621.504-1.125 1.125-1.125Zm15.966 3.767v6.363h4.157v-.967h-3.014v-1.74h2.777v-.958h-2.777v-1.74h2.997v-.958h-4.14Zm-4.869 6.363v-6.363h1.143v5.396h2.812v.967h-3.955Zm-1.186 0v-6.363h-1.143v6.363h1.143Zm-6.188 0v-6.363h4.078v.958h-2.935v1.74h2.654v.958h-2.654v2.707h-1.143Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.971 21.017v6.363h4.157v-.967h-3.014v-1.74h2.777v-.958h-2.777v-1.74h2.997v-.958h-4.14ZM20.102 21.017v6.363h3.955v-.967h-2.812v-5.396h-1.143ZM18.916 27.38v-6.363h-1.143v6.363h1.143ZM12.728 21.017v6.363h1.143v-2.707h2.654v-.958h-2.654v-1.74h2.935v-.958h-4.078Z"
  })));
};
export default SvgAttachmentFile;